import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { FormattedMessage } from "react-intl";
import { Editor } from "components/Form";

/**
 * InterviewSubtitle
 *
 * @param {String} subtitleId
 * @param {String} description
 * @param {Object} descriptionJson
 */
const InterviewSubtitle = ({ subtitleId, description, descriptionJson }) => {
  if (descriptionJson) {
    return <Editor value={descriptionJson} css={[styles.subtitle, styles.editor]} readOnly={true} />;
  }

  if (description) {
    return <p css={styles.subtitle}>{description}</p>;
  }

  return (
    <p css={styles.subtitle}>
      <FormattedMessage id={subtitleId} />
    </p>
  );
};

const styles = {
  subtitle: css`
    font-size: 2rem;
    line-height: 1.4;
    margin: 0;
    white-space: pre-line;
  `,
  editor: css`
    order: 0;
    border: 0;
    box-shadow: none;
  `,
};

InterviewSubtitle.propTypes = {
  subtitleId: PropTypes.string,
  description: PropTypes.string,
  descriptionJson: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default InterviewSubtitle;
